import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ForgottenPasswordComponent } from './forgotten-password/forgotten-password.component';
import { RecoveryPasswordComponent } from './recovery-password/recovery-password.component';
import { ComponentsAdminModule } from '../../admin/componentsAdmin/components-admin.module';
import { TypeRegisterComponent } from './type-register/type-register.component';
import { AcceptMessageComponent } from './accept-message/accept-message.component';
import { TranslateModule } from '@ngx-translate/core';
import { GeneralesComponentsModule } from 'src/app/generales-components/generales-components.module';

const declarations = [
  LoginComponent,
  RegisterComponent,
  ForgottenPasswordComponent,
  RecoveryPasswordComponent,
  TypeRegisterComponent,
  AcceptMessageComponent
]

@NgModule({
  declarations: declarations,
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsAdminModule,
    TranslateModule,
    GeneralesComponentsModule
  ],
  exports: declarations
})
export class LoginComponentModule { }
